import React from "react";

interface RedirectButtonProps {
  transactionHash: string;
  network: string;
  fillColor?: string;
  buttonSize?: string;
  borderRadius?: string;
}

const RedirectButton: React.FC<RedirectButtonProps> = ({
  transactionHash,
  network,
  buttonSize = "20px",
  borderRadius = "4px",
  fillColor = "bg-bg-page-body",
}) => {
  const redirectUrl = (transactionHash: string, network: string) => {
    let url = "";
    if (network.toLowerCase() === "bsc") {
      url = `https://bscscan.com/tx/${transactionHash}`;
    } else if (
      network.toLowerCase() === "matic" ||
      network.toLowerCase() === "pol"
    ) {
      url = `https://polygonscan.com/tx/${transactionHash}`;
    } else if (network.toLowerCase() === "eth") {
      url = `https://etherscan.io/tx/${transactionHash}`;
    } else if (network.toLocaleLowerCase() === "trx") {
      url = `https://tronscan.org/#/transaction/${transactionHash}`;
    }
    window.open(url, "_blank");
  };

  return (
    <div
      className={`flex justify-center items-center cursor-pointer shadow-[0px_2px_4px_0px_rgba(0,0,0,0.08)] ${fillColor} border border-bg-button-secondary`}
      style={{
        width: buttonSize,
        height: buttonSize,
        borderRadius: borderRadius,
        visibility: network !== "TPNK" ? "visible" : "hidden",
      }}
      onClick={() => redirectUrl(transactionHash, network)}
    >
      <span className="material-symbols-outlined text-[14px]">open_in_new</span>
    </div>
  );
};

export default RedirectButton;
